import { Separator } from "Components/ui/separator";
import "./RuleCard.scss";

function RuleCard({
  danger,
  title,
  status = "Passing",
  statusText,
  subtitle,
  children,
  greyDot,
  withoutPadding,
  className,
  newStatus,
}) {
  return (
    <div
      className={`flex flex-col  justify-between overflow-hidden min-h-44 ${
        danger ? "bg-background-cardDanger" : "bg-background"
      } ${!withoutPadding && "p-6"} rounded-xl ${className}`}
    >
      <div className={`${withoutPadding && "p-4"}`}>
        <div className="flex flex-row items-center justify-between">
          <div className="text-lg font-N_Roman responsiveText">{title}</div>

          {!newStatus ? (
            <div
              className={`responsiveInnerText border-2 flex flex-row items-center gap-2 rounded-full px-2 text-base ${
                status === "Passing"
                  ? "border-green text-green"
                  : status === "Failed"
                  ? "border-conditions-failOpacity text-red"
                  : `border-conditions-disabledOpacity text-white-opacity ${
                      !greyDot && "px-3"
                    }`
              }`}
            >
              <div className="font-N_Bold text-sm">{statusText || status}</div>
            </div>
          ) : (
            <div>{statusText || status}</div>
          )}
        </div>
        <Separator
          className={`my-4 h-[0.1rem] ${
            danger ? "bg-background-secondaryOpacity" : "bg-border-darkNew"
          }`}
        />
      </div>
      <div>{subtitle}</div>
      {children}
    </div>
  );
}

export default RuleCard;
